import React, { FC } from 'react';
import { Icon } from '@npm-registry/eapteka-ui';
import { text } from '../../../text';
import { DeletionProps } from './types';
import styles from './Deletion.scss';

export const Deletion: FC<DeletionProps> = ({
  callback
}) => {
  return (
    <button className={styles.root} onClick={callback}>
      <Icon className={styles.icon} name="trash" />
      <span>{text.delete}</span>
    </button>
  );
};
